import { Badge } from "@/components/ui/Badge";
import { Card } from "@/components/ui/Card";
import { GlobalCTA } from "@/components/ui/CTA";
import { List } from "@/components/ui/List";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";
import { Table } from "@/components/ui/Table";
import { productDefinition, productFacts, productModules, productRoadmap } from "@/content/product";
import { capabilityStatusTone } from "@/lib/status";

export default function ProductPage() {
  return (
    <>
      <PageHero
        eyebrow="Product"
        title="Agent-led creative growth with evidence and control"
        description={productDefinition}
      />

      <Section title="Product facts" tone="surface">
        <Table caption="Agentic Plus product facts" rows={productFacts} />
      </Section>

      <Section
        title="Platform modules"
        lead="Each module contributes to one mission context, so teams do not have to reconstruct decisions from disconnected files and threads. Status labels distinguish current scope, pilot scope, and roadmap."
      >
        <div className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {productModules.map((module) => (
            <Card key={module.title} title={module.title} description={module.description}>
              <List items={module.points} className="mt-4" />
              <div className="mt-5">
                <Badge tone={capabilityStatusTone(module.status)}>{module.status}</Badge>
              </div>
            </Card>
          ))}
        </div>
      </Section>

      <Section
        title="Planned expansion"
        lead="These capabilities extend the evidence-to-execution loop. They are not represented as launched features."
        tone="paper"
      >
        <div className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {productRoadmap.map((item) => (
            <Card
              key={item.title}
              title={item.title}
              description={item.description}
              footer={<Badge tone="amber">Planned</Badge>}
            />
          ))}
        </div>
      </Section>

      <GlobalCTA />
    </>
  );
}
